import { render, staticRenderFns } from "./accessoireG.vue?vue&type=template&id=1b152c74&scoped=true&"
import script from "./accessoireG.vue?vue&type=script&lang=js&"
export * from "./accessoireG.vue?vue&type=script&lang=js&"
import style0 from "./accessoireG.vue?vue&type=style&index=0&id=1b152c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b152c74",
  null
  
)

export default component.exports